import React, { useContext } from 'react';
import { TextLayerExtension } from '@meitu/saas-editor-core/es/editor/layer-extensions/text-layer';
import { OpacitySlider } from '@/components/opacity-slider';
import { useEditor } from '@/hooks/use-editor';
import { TextPanelContext } from '../../context';
import { useLayerProps } from '../../hooks';
import { Tracker } from '../../utils';

export const LayerOpacity: React.FC = () => {
    const { layerId, recordId } = useContext(TextPanelContext)!;

    const editor = useEditor();
    const opacity = useLayerProps(editor, (layer) => {
        return layer ? layer.opacity : 1;
    }) as number;

    const layerOpacity = ~~(opacity * 100);

    const setOpacity = (value: number, options = { writeHistory: true }) => {
        editor.getInstance(TextLayerExtension).setLayerOpacity(layerId, value / 100, options);

        if (options.writeHistory) {
            Tracker.setLayerOpacity({
                recordId,
                stageType: editor.stage.getType(),
                opacity: value,
            });
        }
    };

    return (
        <OpacitySlider
            value={layerOpacity}
            onChange={(value) => setOpacity(value, { writeHistory: false })}
            onAfterChange={(value) => setOpacity(value, { writeHistory: true })}
        />
    );
};
